import { useParams } from "react-router-dom";
import { FlexRow } from "atoms";
import { CartButton } from "./CartButton";
import { CartDetails } from "./CartDetails";
import { CollectionDetails } from "./CollectionDetails";
import { CollectionList } from "./CollectionList";
import { ProductDetails } from "./ProductDetails";

function DevShop() {
  const { type, handle } = useParams<{
    type: "cart" | "products" | "collections";
    handle: string;
  }>();

  return (
    <div style={{ padding: "2rem" }}>
      <FlexRow
        style={{
          borderBottom: "1px solid",
          justifyContent: "space-between",
          paddingBottom: "1rem",
          marginBottom: "2rem",
        }}
      >
        <span>SHOP</span>
        <CartButton />
      </FlexRow>

      {!type && <CollectionList />}

      {type === "cart" && <CartDetails />}

      {type === "collections" && handle && (
        <CollectionDetails handle={handle} />
      )}

      {type === "products" && handle && <ProductDetails handle={handle} />}
    </div>
  );
}

export default DevShop;
